// routes name
export const homepageURL = "/";
export const privacypolicyURL = "/privacy-policy";
export const termsandconditionURL = "/terms-and-conditions";
export const contactNo = "+91 7021 502 288";
export const whatsappURL = "https://wa.me/+917021502288";
